import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 10px;
    border: none;
  }
  
  .modal-header {
    background-color: #ff3366;
    color: white;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: none;
  }
  
  .modal-body {
    max-height: 60vh;
    overflow-y: auto;
    padding: 20px;
    font-size: 14px;
  }
  
  .modal-footer {
    border-top: none;
  }
  
  .close-button {
    background-color: #ff3366;
    border: none;
    &:hover, &:focus, &:active {
      background-color: #e62e5c !important;
      box-shadow: none !important;
    }
  }
`;

const TermsAndConditions = ({ show, handleClose }) => {
  return (
    <StyledModal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Terms and Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>Closeup Break The Barrier – Publish your love stories</h5>
        <ol>
          <li>The contest is open to all Sri Lankans and legal residents over the age of 18 years.</li>
          <li>The best creative stories will be judged by a panel of judges appointed by the brand team, and the decision of the panel will be final.</li>
          <li>Participants must fill out the form on www.CloseupBreakTheBarrier.lk and submit their love stories or experiences via the site. Any content published elsewhere will not be considered or eligible for this campaign.</li>
          <li>Content gathered through the site may be published at the discretion of the brand team or the designated agency nominated by the brand team. However, participants may opt to publish their story with their name or anonymously.</li>
          <li>Respondents will bear the responsibility for their submissions and for any harm caused by submissions, and the brand or its agencies will not be responsible for any losses.</li>
          <li>To be eligible for the competition, entrants must provide accurate details in the form provided.</li>
          <li>The campaign is scheduled to take place from 14th March 2025 to 31st March 2025, subject to change at the discretion of the brand team, which will be communicated on its official social media channels.</li>
          <li>By the end of the competition, one winner selected by the judge panel will win the grand prize of Closeup's sponsorship to publish their book. The value of this sponsorship will be determined by the brand team after engaging with a publisher decided at the discretion of the brand team.</li>
          <li>Fifteen more winners will be picked based on the creativity of their stories. They will win a chance to publish their stories in Sri Lanka's first-ever crowd-sourced love story book, a gift pack of Unilever products worth Rs 10,000, and a cash prize of Rs 10,000.</li>
          <li>Twenty-five (25) winners will be picked for cash prizes worth Rs 10,000, selected based on a random draw.</li>
          <li>Employees of Unilever and its authorized agencies, and their immediate relatives, are not eligible to participate in this competition.</li>
          <li>All winners are required to sign a valid receipt upon accepting their prize.</li>
          <li>The prizes are non-exchangeable, non-transferable, and are not redeemable for cash or other prizes.</li>
          <li>The winners may be required to take part in promotional activity related to the contest and the winners shall participate in such activity on Unilever's reasonable written request. The winner consents to the use by Unilever and its related companies, both before and after the closing date of the contest for an unlimited time, of their voices, images, photographs, and names for publicity purposes (in any medium, including still photographs and films, and on the internet, including any websites hosted by Unilever and its related companies) and in advertising, marketing or promotional material without additional compensation or prior notice and, in entering the contest, all entrants consent to the same.</li>
          <li>Unilever reserves the right at any time and from time to time to modify or discontinue, temporarily or permanently, this contest with or without prior notice due to reasons outside its control (including, without limitation, in the case of anticipated, suspected, or actual fraud). The decision of Unilever in all matters under its control relating to the contest is final and binding and no correspondence will be entered into in this regard.</li>
          <li>The collection, storage and processing of your information shall be governed by Unilever's privacy policy which can be found at www.unileverprivacypolicy.com</li>
          <li>The draw will be governed by Sri Lankan law and entrants to the contest submit to the exclusive jurisdiction of the Sri Lankan courts.</li>
          <li>Entrants into the contest shall be deemed to have accepted these Terms and Conditions.</li>
        </ol>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" className="close-button" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </StyledModal>
  );
};

export default TermsAndConditions;
